export default function BrandLogo({ variant = "header", light = false, testId = "brand-logo" }) {
  return (
    <span className={`brand-logo brand-logo-${variant} ${light ? "brand-logo-light" : ""}`} data-testid={testId}>
      <img
        className="brand-logo-image"
        src="/job-boost-by-ben-logo.png"
        alt="Job Boost by Ben"
        data-testid={`${testId}-image`}
        loading="eager"
      />
      <span className="sr-only" data-testid={`${testId}-main`}>Job Boost</span>
      <span className="sr-only" data-testid={`${testId}-byline`}>by Ben</span>
    </span>
  );
}